import { render, staticRenderFns } from "./PolicyExpressItem.vue?vue&type=template&id=3e156214&scoped=true&"
import script from "./PolicyExpressItem.vue?vue&type=script&lang=js&"
export * from "./PolicyExpressItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e156214",
  null
  
)

export default component.exports